module.exports = __webpack_public_path__ + "static/geneva-business-school-7becc0d9ed42fcf86fc05522526d44df.png";